import type {
  SocialPostSceneImageBlockV1,
  SocialPostSceneLogoBlockV1,
  SocialPostSceneRectBlockV1,
  SocialPostSceneTextBlockV1,
} from "./social-post-scene.ts";

type CoordinateMode = "absolute" | "local";

const resolveBlockOrigin = (
  block: Pick<SocialPostSceneRectBlockV1, "x" | "y">,
  scale: number,
  mode: CoordinateMode,
) => ({
  x: mode === "local" ? 0 : block.x * scale,
  y: mode === "local" ? 0 : block.y * scale,
});

export const toKonvaRectNodeProps = (
  block: SocialPostSceneRectBlockV1,
  scale: number,
  mode: CoordinateMode = "absolute",
) => ({
  ...resolveBlockOrigin(block, scale, mode),
  width: block.width * scale,
  height: block.height * scale,
  rotation: mode === "local" ? 0 : block.rotation,
  opacity: mode === "local" ? 1 : block.opacity,
  fill: block.fill,
  stroke: block.stroke,
  strokeWidth: block.strokeWidth * scale,
  cornerRadius: block.cornerRadius * scale,
});

export const toKonvaTextNodeProps = (
  block: SocialPostSceneTextBlockV1,
  scale: number,
  mode: CoordinateMode = "absolute",
) => ({
  ...resolveBlockOrigin(block, scale, mode),
  width: block.width * scale,
  height: block.height * scale,
  rotation: mode === "local" ? 0 : block.rotation,
  opacity: mode === "local" ? 1 : block.opacity,
  text: block.text,
  fill: block.fill,
  stroke: block.stroke,
  strokeWidth: (block.strokeWidth ?? 0) * scale,
  fillAfterStrokeEnabled: Boolean(block.stroke && (block.strokeWidth ?? 0) > 0),
  fontFamily: block.fontFamily,
  fontSize: block.fontSize * scale,
  fontStyle: block.fontStyle,
  align: block.align,
  verticalAlign: block.verticalAlign,
  lineHeight: block.lineHeight,
  letterSpacing: block.letterSpacing * scale,
  padding: block.padding * scale,
});

export const toKonvaImageFrameProps = (
  block: SocialPostSceneImageBlockV1 | SocialPostSceneLogoBlockV1,
  scale: number,
  mode: CoordinateMode = "absolute",
) => ({
  ...resolveBlockOrigin(block, scale, mode),
  width: block.width * scale,
  height: block.height * scale,
  rotation: mode === "local" ? 0 : block.rotation,
  opacity: mode === "local" ? 1 : block.opacity,
  cornerRadius: block.cornerRadius * scale,
  fit: block.fit,
});
